import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import RHFController from "../Form/RHFController";
import CustomTransferList from "./CustomTransferList";

const TransferList = ({
  name,
  label,
  label1,
  label2,
  items,
  defaultSelectedValue,
  maxItems,
  maxValue,
  field,
  readyOnly,
  single
}) => {
  const { register, control } = useFormContext();

  return (
    <RHFController
      {...{
        register,
        name,
        render: ({ onChange }) => (
          <CustomTransferList
            label={label}
            label1={label1}
            label2={label2}
            items={items}
            defaultSelectedValue={defaultSelectedValue}
            maxItems={maxItems}
            maxValue={maxValue}
            onChange={onChange}
            field={field}
            readyOnly={readyOnly}
            single={single}
          />
        ),
      }}
    />
  );
};

TransferList.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  label1: PropTypes.string,
  label2: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  maxItems: PropTypes.number,
  maxValue: PropTypes.number,
  field: PropTypes.string.isRequired,
  readyOnly: PropTypes.bool,
};

export default TransferList;
